import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '../shapes/Spinner';
const defaultNoDataText = 'Loading...';
const TableSpinner = ({ loading, loadingText, entireHeaderHeight }) => {
    if (!loading) {
        return null;
    }
    return (React.createElement("div", { style: {
            position: 'absolute',
            left: 0,
            top: entireHeaderHeight,
            bottom: 0,
            width: '100%',
            backgroundColor: 'rgba(255,255,255,0.8)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        } },
        React.createElement(Spinner, null),
        loadingText || defaultNoDataText));
};
TableSpinner.propTypes = {
    loading: PropTypes.bool,
    loadingText: PropTypes.node,
    entireHeaderHeight: PropTypes.number,
};
TableSpinner.defaultProps = {
    entireHeaderHeight: 0,
};
export default TableSpinner;
